import React from "react";
import websiteData from '../data.json';
import CoverHeaderXs from '../components/header/cover-header-xs';
import ScrollableAnchor from 'react-scrollable-anchor';
import SectionContainer from '../components/containers/section-container';
import Heading2Paragraph from '../components/titles/heading2-paragraph';
import FeatureServices from '../components/features/featureservices';
import FeatureServicesInline from '../components/features/featureservicesinline';
import FeaturesAccordionSection from '../components/features/featuresaccordion';
import ReactGA from 'react-ga';

export const initGA = () => {
    /* console.log('Ga init'); */
    ReactGA.initialize('UA-90162173-1');
}

export const logPageView = () => {
    /* console.log(window.location.pathname); */
    ReactGA.set({ page: window.location.pathname });
    ReactGA.pageview(window.location.pathname);
}

export default class ServicesPage extends React.Component {
    componentDidMount() {
        initGA();
        logPageView();
    }
    render() {
        const servicesPage = websiteData.servicesPage,
              dataCoverHeaderXs = servicesPage.CoverHeaderXs[0],
              dataServicesWhatWeOffer = servicesPage.servicesWhatWeOffer,
              dataServicesWhatWeOfferGrid = servicesPage.FeatureServices.servicesWhatWeOfferGrid,
              dataServiceshowWeWork = servicesPage.serviceshowWeWork,
              dataServiceshowWeWorkGrid = servicesPage.FeatureServicesInline.serviceshowWeWorkGrid,
              dataServicesQuestions = servicesPage.servicesQuestions,
              dataServicesQuestionsList = servicesPage.FeaturesAccordionSection.servicesQuestionsList;             
        return (
            <div id="page">
                <CoverHeaderXs backgroundImage={ dataCoverHeaderXs.headerBackgroundImage } headerSizeClass={ dataCoverHeaderXs.headerSizeClass } headerTitle={ dataCoverHeaderXs.headerTitle } headerSubTitle={ dataCoverHeaderXs.headerSubTitle }/>
                <div className="gtco-section border-bottom">
                    <SectionContainer>
                        <ScrollableAnchor id={'offer'}>
                            <Heading2Paragraph content={ { title: dataServicesWhatWeOffer.title, paragraph: dataServicesWhatWeOffer.paragraph } } />
                        </ScrollableAnchor>
                        <FeatureServices content={ dataServicesWhatWeOfferGrid } />
                    </SectionContainer>
                </div>
                <div className="gtco-section" id="gtco-items-flex">
                    <SectionContainer>
                        <ScrollableAnchor id={'gtco-how-we-work'}>
                            <Heading2Paragraph content={ { title: dataServiceshowWeWork.title, paragraph: dataServiceshowWeWork.paragraph } } />
                        </ScrollableAnchor>
                        <FeatureServicesInline content={ dataServiceshowWeWorkGrid } />
                    </SectionContainer>
                </div>   
                <hr />  
                <div className="gtco-section">
                    <SectionContainer>
                        <ScrollableAnchor id={'questions'}>
                            <Heading2Paragraph content={ { title: dataServicesQuestions.title, paragraph: dataServicesQuestions.paragraph } } />
                        </ScrollableAnchor>
                        <FeaturesAccordionSection content={ dataServicesQuestionsList } />
                    </SectionContainer>
                </div>                             
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/pages/services-page.js